import { useState, useEffect } from "react";
import * as FeatherIcon from 'react-feather';

import './WizardSidebar.css';


// ----------------------------
// BusinessSegment Component
// ----------------------------
const BusinessSegment = ({ onNext, onPrev, updateData, data }) => {
    const segmentsList = [
      "Pharma Distribution",
      "Surgical Supplies",
      "Retail",
      "Long term care",
      "Diagnostics",
      "Patient Support"
    ];
    const [primary, setPrimary] = useState(data.primaryIndustry || "");
    const [sub, setSub] = useState(data.subIndustry || "");
    const [segments, setSegments] = useState(data.segments || []);
  
    useEffect(() => {
      updateData({ primaryIndustry: primary, subIndustry: sub, segments });
    }, [primary, sub, segments]);
  
    const toggleSegment = (segment) => {
      setSegments((prev) =>
        prev.includes(segment) ? prev.filter((s) => s !== segment) : [...prev, segment]
      );
    };
  
    return (
      <div className="wizard_one">
        <h5 className="custom_lable">Primary Industry</h5>
        <select className="form-select mb-3 custom_input_text" value={primary} onChange={(e) => setPrimary(e.target.value)}>
          <option value="">Select Primary Industry</option>
          <option value="Medical Distribution">Medical Distribution</option>
          <option value="Diagnostics">Diagnostics</option>
        </select>
  
        <h5 className="custom_lable">Sub-Industry</h5>
        <select className="form-select mb-3 custom_input_text" value={sub} onChange={(e) => setSub(e.target.value)}>
          <option value="">Select Sub-industry</option>
          <option value="Healthcare Distribution">Healthcare Distribution</option>
          <option value="Lab Supplies">Lab Supplies</option>
        </select>
  
        <h5 className="custom_lable">Segments</h5>
        <div className="row">
          {segmentsList.map((seg, idx) => (
            <div className="col-6" key={idx}>
              <div className="form-check ">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`segment-${idx}`}
                  checked={segments.includes(seg)}
                  onChange={() => toggleSegment(seg)}
                />
                <label className="form-check-label custom_checkbox_lable" htmlFor={`segment-${idx}`}>{seg}</label>
              </div>
            </div>
          ))}
        </div>
  
        <div className="mt-4">
          <button className="btn btn-secondary previous_btn_wz me-2" disabled onClick={onPrev}>
            <FeatherIcon.ChevronLeft className='prev_feather'/> Previous
            </button>
          <button className="btn btn-primary next_btn_wz" onClick={onNext}> Next <FeatherIcon.ChevronRight className='next_feather'/></button>
        </div>
      </div>
    );
  };

  export default BusinessSegment;